import React, { useState, useEffect } from 'react';

const MotivationalQuote = () => {
  const quotes = [
    "Keep up the great work!",
    "Almost there 👏",
    "You’re doing amazing!",
    "One step closer to your goal 🚀",
    "Every minute counts ⏳",
    "Stay focused, you're doing great!",
    "Your effort matters 💪",
    "Crushing it today 🔥",
    "Believe in the process 🙌",
    "You're closer than you think!"
  ];

  const [quote, setQuote] = useState('');

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * quotes.length);
    setQuote(quotes[randomIndex]);
  }, []); // Runs only once on mount

  return (
    <div>
      {quote}
    </div>
  );
};

export default MotivationalQuote;
